<template>
  <v-card>
    <v-card-title> صفحات درخواست انتشار
        <v-spacer/>
        <div>
            <v-btn 
            color="error"
            @click="$store.commit('setPagePublishRequest', false)">
                بستن
            </v-btn>
        </div>
    </v-card-title>
    <v-divider/>
    <v-card-text>
        <advance-filter
          ref="advanceFillterRef"
          :column="filterColumn"
          @getList="showPublishRequestPage"
          @saveFilter="saveFilter"
          :savedFilters="savedFilters"
          class="mb-5"
        ></advance-filter>
        <base-table
          :items="publishRequestItems"
          :headers="publishRequestHeaders"
          class="elevation-1"
          disable-pagination
          hide-default-footer>
          <template v-slot:[`item.pageIndexImageId`]="{ item }">
            <v-img 
            :alt="item.pageIndexImageId && item.pageIndexImageId.alt? item.pageIndexImageId.alt:''"
            :src="item.pageIndexImageId && item.pageIndexImageId.thumbnailFileUrl? item.pageIndexImageId.thumbnailFileUrl : ''"
             width="50"
              height="50"
            >
            </v-img>
          </template>
           <template v-slot:[`item.summary`]="{ item }">
            {{
              item.summary&& item.summary.length > 30
                ? item.summary.slice(0, 30) + "..."
                : item.summary
            }}
          </template>
          <template v-slot:[`item.confimedDateUtc`]="{ item }">
            {{
              item.confimedDateUtc ? (item.confimedDateUtc | moment) : ''
            }}
          </template>
           <template v-slot:[`item.disabled`]="{ item }">
            <span>{{
              item.disabled
                ? 'غیرفعال'
                : 'فعال'
            }}</span>
          </template>
           <template v-slot:[`item.confirmed`]="{ item }">
            <span>{{
              item.confirmed== true
                ? 'تایید شده'
                : item.confirmed== null
                ?'در انتظار تایید'
                : item.confirmed== false
                ? 'رد شده':''
            }}</span>
          </template>
          <template v-slot:[`item.confirmedDateUtc`]="{ item }">
            <span>{{
              item.confirmedDateUtc ? (item.confirmedDateUtc | moment) : ''
            }}</span>
          </template>
        </base-table>
        <div class="text-center pt-8">
          <v-row>
            <v-col cols="12" sm="2" md="2">
              <v-select
                outlined
                dense
                v-model="itemsPerPage"
                :items="[5, 10, 20]"
                label="تعداد نمایش در صفحه"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="10" md="10">
              <v-pagination
                circle
                v-model="pageNumber"
                :length="pageCount"
                :total-visible="7"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { RepoFactory } from "@/baseRepository/Factory";
const pagesRepository = () => RepoFactory.get("pages");
const enumsRepository = () => RepoFactory.get("enums");

import Helper from "@/core/helpers";
import qs from "qs";
import AdvanceFilter from "@/components/core/AdvanceFilter";

export default {
data(){
    return{
        filterColumn:[],
      savedFilters:[],
        pagesItems: [],
      pageNumber: 1,
      itemsPerPage: 10,
      pageCount: 0,
        publishRequestItems:[],
        publishRequestHeaders:[
        {
          value: "pageIndexImageId",
          text: "تصویر شاخص",
          sortable: false,
        },
        {
          value: "pageTitle",
          text: "عنوان صفحه",
          sortable: false,
        },
        {
          value: "confirmedDateUtc",
          text: "تاریخ انتشار",
          sortable: true,
        },
        {
          value: "summary",
          text: "خلاصه",
          sortable: true,
        },

        {
          value: "disabled",
          text: "وضعیت",
          sortable: false,
        },
        {
          value: "confirmed",
          text: "تاییدشده/ردشده",
          sortable: false,
        },
      ]
    }
},
computed:{
    baseUrl(){
        return this.$store.getters.contentBaseUrl;
    }
},
 watch: {
    pageNumber() {
      this.showPublishRequestPage();
    },
    itemsPerPage() {
      this.showPublishRequestPage();
    },
 },
created(){
    this.getClassTypeModel();
    if (localStorage.getItem("publishRequestPagesFilter")) {
      this.savedFilters = JSON.parse(localStorage.getItem("publishRequestPagesFilter"));
    }
    this.showPublishRequestPage()
},
methods:{
    getClassTypeModel() {
      enumsRepository()
        .getModel("PagePublishRequestListDto", this.baseUrl)
        .then((res) => {
          this.filterColumn = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    saveFilter(){
      localStorage.setItem(
        "publishRequestPagesFilter",
        JSON.stringify(this.$refs.advanceFillterRef.Filters)
      );
    },
    showPublishRequestPage(){
      let params = {
        PageNumber: this.pageNumber,
        ItemsPerPage: this.itemsPerPage,
      };
       if (
        (this.$refs.advanceFillterRef &&
        this.$refs.advanceFillterRef.Filters.length)
   
      ) {
        params.Filters = this.$refs.advanceFillterRef.Filters;

        params.Filters.forEach((element) => {
          delete element.arrayOfValue;
          delete element.enumValues;
          delete element.type;
          delete element.typeOfValue;
        });
      }
       if (this.savedFilters && this.savedFilters.length){
        if(params.Filters && params.Filters.length){
        params.Filters.concat(this.savedFilters)}
        else{
        params.Filters = this.savedFilters

        }
       }
      const loader = this.$loading.show()
        pagesRepository()
        .showPublishRequest( this.baseUrl,
        {MerchantId: this.$store.getters.currentMerchant}, 
        params,
        (params) => {return qs.stringify(params, { allowDots: true })})
        .then((res)=>{
        this.publishRequestItems = res.data.list
        this.pageCount = Math.ceil(res.data.totalCount / this.itemsPerPage);
        })
        .catch((err)=>{
          Helper.handleErrors(err, this);
              })
        .finally(()=>{
        loader.hide()
        })
    },
},

components:{
    AdvanceFilter
}
}
</script>

<style>

</style>